import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    CMSHabitatAssayType,
    ProjectDefinitionCompletionStatus,
    SamplingEvent,
    FeatureType,
    HabitatInsightsGeoJson,
} from 'src/shared/types';

export type NewProjectDefinitionFormState = {
    // Basic information
    projectId: string;
    projectName: string;
    projectCode: string;
    features: FeatureType[];
    subscriptionType?: string;
    country: string;
    projectDefinitionCompletionStatus: ProjectDefinitionCompletionStatus | null;
    // Project contact
    projectLeadName: string;
    projectLeadEmail: string;
    projectLeadRole: string;

    // Sampling cadence
    samplingEvents: Pick<SamplingEvent, 'name' | 'fromDate' | 'toDate' | 'year'>[];
    sampleGroups: string[];

    // Habitat assay types
    habitatAssayTypes: Pick<CMSHabitatAssayType, 'assayName' | 'habitatAssayKey' | 'habitatName'>[];

    // Sampling events known
    hasDefinedSampleEvents: boolean;

    // Habitat Insights
    habitatInsightsUploadedFileContent: string;
    habitatInsightsUploadedFileErrors: Array<{ type: string; message: string }>;
    habitatInsightsUploadedFileName: string;
    habitatInsightsSites: HabitatInsightsGeoJson[];
    habitatInsightsRunCloudJobs: boolean;
};

export const defaultProjectDefinitionFormState = {
    projectId: '',
    projectName: '',
    projectCode: '',
    features: [],
    country: '',
    projectLeadRole: '',
    projectLeadName: '',
    projectLeadEmail: '',
    samplingEvents: [],
    sampleGroups: [],
    habitatAssayTypes: [],
    projectDefinitionCompletionStatus: null,
    hasDefinedSampleEvents: false,
    habitatInsightsUploadedFileContent: '',
    habitatInsightsUploadedFileErrors: [],
    habitatInsightsUploadedFileName: '',
    habitatInsightsSites: [],
    habitatInsightsRunCloudJobs: true,
};

type ProjectDefinitionState = {
    formState: NewProjectDefinitionFormState;
};

const initialState: ProjectDefinitionState = {
    formState: { ...defaultProjectDefinitionFormState },
};

const newProjectDefinitionSlice = createSlice({
    name: 'newProjectDefinition',
    initialState,
    reducers: {
        setFormState(state, action: PayloadAction<Partial<NewProjectDefinitionFormState>>) {
            state.formState = { ...state.formState, ...action.payload };
        },

        reset(state) {
            // eslint-disable-next-line
            state.formState = { ...defaultProjectDefinitionFormState };
        },
    },
});

export default newProjectDefinitionSlice.reducer;

export const { setFormState, reset } = newProjectDefinitionSlice.actions;
